'use client';

import { useCallback, useMemo } from 'react';

import { NavLayout } from '@shared/common/components/NavLayout';
import {
  storePrimaryNav,
  storeQuickNavItems,
} from '@shared/common/components/NavLayout/navSetting';
import { useAuth } from '@shared/common/providers/AuthProvider';
import {
  useAuthModal,
  useBanxaModal,
  useSupportModal,
} from '@shared/common/providers/GlobalModalsProvider';
import { useFeatureToggles } from '@shared/hooks/useFeatureToggles';

import { MagicsquareLogo } from '@ui/uikit/components/logos/MagicsquareLogo';

const Navigation = () => {
  const { showAiAgentsPage, showMemesPage, showTelegramMiniAppsPage } = useFeatureToggles();

  const { user, isLoading, logout, userEvmWallet } = useAuth();

  const authModal = useAuthModal();
  const banxaModal = useBanxaModal();
  const supportModal = useSupportModal();

  const handleBanxaBuyToken = useCallback(() => {
    banxaModal.open({
      walletAddress: userEvmWallet?.attributes.address,
    });
  }, [banxaModal, userEvmWallet]);

  const handleConnectClick = useCallback(() => {
    authModal.open();
  }, [authModal]);

  const handleLogout = useCallback(() => {
    logout();
  }, [logout]);

  const handleSupport = useCallback(() => {
    supportModal.open();
  }, [supportModal]);

  const filteredStorePrimaryNav = useMemo(
    () =>
      storePrimaryNav.filter((item) => {
        if (item.id === 'aiAgents' && !showAiAgentsPage) {
          return false;
        }

        if (item.id === 'memes' && !showMemesPage) {
          return false;
        }

        if (item.id === 'telegramMiniApps' && !showTelegramMiniAppsPage) {
          return false;
        }

        return true;
      }),
    [showAiAgentsPage, showMemesPage, showTelegramMiniAppsPage],
  );

  return (
    <NavLayout
      logo={MagicsquareLogo}
      isLoading={isLoading}
      user={user ? { data: user } : undefined}
      onLogin={handleConnectClick}
      onLogout={handleLogout}
      onSupport={handleSupport}
      onBanxaBuyToken={handleBanxaBuyToken}
      primaryNavItems={filteredStorePrimaryNav}
      quickNavItems={storeQuickNavItems}
      portalMode="overlay"
    />
  );
};

export { Navigation };
